import { createFileRoute, Link } from "@tanstack/react-router";
import { AuthFrame } from "@/components/marketing/auth-frame";
import { Button } from "@/components/ui/button";
import { CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export const Route = createFileRoute("/account-closed")({
  component: AccountClosedPage,
  head: () => ({ meta: [{ title: "Account closed | People AI" }] }),
});

/** Where "Delete my account" lands once the account is switched off and signed out. */
function AccountClosedPage() {
  return (
    <AuthFrame>
      <CardHeader className="items-center text-center">
        <CardTitle asChild className="text-xl">
          <h1>Your account is closed</h1>
        </CardTitle>
        <CardDescription>You are signed out on every device.</CardDescription>
      </CardHeader>
      <CardContent className="text-muted-foreground space-y-3 text-sm">
        <p>
          We delete your login and your personal details within 30 days and email you when it is
          done. Until then nobody can sign in with it.
        </p>
        <p>
          Records you made for residents, such as notes, medication records and signed documents,
          stay with your community, because the law requires it to keep them.
        </p>
        <p>
          Changed your mind? Email{" "}
          <a className="text-foreground underline underline-offset-4" href="mailto:info@ppl-ai.com">
            info@ppl-ai.com
          </a>{" "}
          before then and we can switch it back on.
        </p>
        <Button asChild className="w-full" variant="outline">
          <Link to="/legal/delete-account">How account deletion works</Link>
        </Button>
      </CardContent>
    </AuthFrame>
  );
}
